"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.scrollable=exports.px=exports.inputScrollable=exports.elevation=exports.TextTruncate=exports.Scrollable=exports.Pointer=exports.Hover=exports.HideOnTablet=exports.HideOnMobile=exports.HideOnDesktop=exports.HiddenBlock=exports.Flex=exports.Elevation=exports.Button=void 0;var _styledComponents=_interopRequireWildcard(require("styled-components"));var _constants=require("../_constants");function _getRequireWildcardCache(e){if("function"!=typeof WeakMap)return null;var r=new WeakMap(),t=new WeakMap();return(_getRequireWildcardCache=function(e){return e?t:r;})(e);}function _interopRequireWildcard(e,r){if(!r&&e&&e.__esModule)return e;if(null===e||"object"!=typeof e&&"function"!=typeof e)return{default:e};var t=_getRequireWildcardCache(r);if(t&&t.has(e))return t.get(e);var n={__proto__:null},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var u in e)if("default"!==u&&{}.hasOwnProperty.call(e,u)){var i=a?Object.getOwnPropertyDescriptor(e,u):null;i&&(i.get||i.set)?Object.defineProperty(n,u,i):n[u]=e[u];}return n.default=e,t&&t.set(e,n),n;}const px=value=>/^\d+(\.\d+)?$/.test(value)?`${value}px`:value;exports.px=px;const Flex=exports.Flex=_styledComponents.default.div`
  display: ${props=>props.inline?'inline-flex':'flex'};
  align-items: ${props=>props.baseline?'baseline':'center'};
  ${props=>props.between&&'justify-content: space-between;'}
  ${props=>props.col&&'flex-direction: column;'}
`;const HideOnDesktop=exports.HideOnDesktop=_styledComponents.default.div`
  @media (${_constants.MEDIA.SMALL_DESKTOP}) {
    display: none !important;
  }
`;const HideOnTablet=exports.HideOnTablet=_styledComponents.default.div`
  @media (${_constants.MEDIA.TABLET}) {
    display: none !important;
  }
`;const HideOnMobile=exports.HideOnMobile=_styledComponents.default.div`
  display: none !important;

  @media (${_constants.MEDIA.TABLET}) {
    display: ${props=>// eslint-disable-next-line no-nested-ternary
props.flex?'flex':props.inline?'inline':'block'} !important;
  }
`;const HiddenBlock=exports.HiddenBlock=_styledComponents.default.div`
  display: ${_ref=>{let{show,flex}=_ref;return show&&(flex?'flex':'block')||'none';}};
`;const Pointer=exports.Pointer=_styledComponents.default.div`
  cursor: ${props=>props.disabled?'default':'pointer'};
  pointer-events: ${props=>props.disabled?'none':'all'};
`;const Hover=exports.Hover=(0,_styledComponents.default)(Pointer)`
  > * { transition: color 0.2s ease-out; }
  svg { transition: fill, stroke 0.2s ease-out; }

  &:hover {
    ${props=>props.color&&`* { color: ${props.color} !important; }`}
    ${props=>props.fill&&`svg { fill: ${props.fill} !important; }`}
    ${props=>props.stroke&&`svg { stroke: ${props.stroke} !important; }`}
  }

  ${props=>props.active&&`
    ${props.color&&`* { color: ${props.color} !important; }`}
    ${props.fill&&`svg { fill: ${props.fill} !important; }`}
    ${props.stroke&&`svg { stroke: ${props.stroke} !important; }`}
`}
`;const TextTruncate=exports.TextTruncate=_styledComponents.default.div`
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;const scrollable=function(){let{color:sColor,background:sBackground,light,thin,width=thin?4:6,margin,offset=0,radius=8}=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};const color=sColor??(light?_constants.COLORS.WHITE_20:_constants.COLORS.PALE_BLUE);const background=sBackground??(light?_constants.COLORS.TRANSPARENT:_constants.COLORS.LIGHT_GRAY);return(0,_styledComponents.css)`
    overflow: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    ${Number.isInteger(margin)&&`margin-right: -${margin}px; padding-right: ${margin}px;`}

    &::-webkit-scrollbar {
      width: ${width}px;
      height: ${width}px;
      border-radius: ${radius}px;
      background-color: ${background};
    }

    &::-webkit-scrollbar-thumb {
      background: ${color};
      border-radius: ${radius}px;
    }

    &::-webkit-scrollbar-thumb:active {
      border-radius: ${radius}px;
    }

    &::-webkit-scrollbar-thumb:vertical {
      min-height: 10px;
    }

    &::-webkit-scrollbar-thumb:horizontal {
      min-width: 10px;
    }

    &::-webkit-scrollbar-track-piece:end {
      margin-bottom: ${offset}px;
    }

    &::-webkit-scrollbar-track-piece:start {
      margin-top: ${offset}px;
    }
  `;};exports.scrollable=scrollable;const Scrollable=exports.Scrollable=_styledComponents.default.div`
  min-height: ${_ref2=>{let{minHeight='100%'}=_ref2;return minHeight;}};
  height: ${_ref3=>{let{height='100%'}=_ref3;return height;}};
  ${_ref4=>{let{light}=_ref4;return scrollable({light});}}
`;const inputScrollable=()=>scrollable({width:5,color:_constants.COLORS.PALE_BLUE_40,background:_constants.COLORS.PALE_BLUE_20});exports.inputScrollable=inputScrollable;const Button=exports.Button=_styledComponents.default.button.attrs(props=>({type:props.type||'button'}))`
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  text-align: left;
  padding: 0;
`;const elevation=function(){let{level,rgb=[0,0,0],noName}=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};const finalLevel=Number.isNaN(+level)?level:+level;const rgbStr=rgb.join(',');const shadow=(a,b,c)=>{const first=`0 ${a[0]}px ${a[1]}px ${a[2]}px rgba(${rgbStr}, 0.2)`;const second=`0 ${b[0]}px ${b[1]}px ${b[2]||0}px rgba(${rgbStr}, 0.14)`;const third=`0 ${c[0]}px ${c[1]}px ${c[2]||0}px rgba(${rgbStr}, 0.12)`;return`${noName?'':'box-shadow:'}${first}, ${second}, ${third} !important;`;};switch(finalLevel){case 0:return`${noName?'':'box-shadow:'}0px 0px rgba(0,0,0,0) !important;`;case 1:return shadow([2,1,-1],[1,1],[1,3]);case 2:return shadow([3,1,-2],[2,2],[1,5]);case 3:return shadow([3,3,-2],[3,4],[1,8]);case 4:return shadow([2,4,-1],[4,5],[1,10]);case 5:return shadow([3,5,-1],[5,8],[1,14]);case 6:return shadow([3,5,-1],[6,10],[1,18]);case 7:return shadow([4,5,-2],[7,10,1],[2,16,1]);case 8:return shadow([5,5,-3],[8,10,1],[3,14,2]);case 9:return shadow([5,6,-3],[9,12,1],[3,16,2]);default:return'';}};exports.elevation=elevation;const Elevation=exports.Elevation=_styledComponents.default.div`
  ${props=>elevation(props)}
`;